import { css } from '@emotion/react';
import { DesignToken, RadiusToken, SpacingToken } from '@livechat/design-system-react-components';

export const formMessage = css`
  margin-bottom: var(${SpacingToken.Spacing7});
`;

export const messageSuccess = css`
  color: var(${DesignToken.SurfaceAccentEmphasisHighInfo});
`;

export const messageError = css`
  color: var(${DesignToken.ContentBasicNegative});
  background: var(${DesignToken.SurfaceAccentEmphasisMinNegative});
  padding: var(${SpacingToken.Spacing3}) var(${SpacingToken.Spacing6});
  font-size: 14px;
  border-radius: var(${RadiusToken.Radius3});
  display: flex;
  align-items: center;
  text-align: left;
`;

export const messageIconStyle = css`
  margin-right: var(${SpacingToken.Spacing4});
`;
